import React from 'react';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { ErrorState } from '../../../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';
import { IncomeTableSkeleton } from './components/IncomeTableSkeleton/IncomeTableSkeleton';

interface Props {
  title: string;
  onRetry?(): void;
}

export const IncomeDetailsError = ({ title, onRetry }: Props) => {
  return (
    <IncomeTableSkeleton title={title}>
      <Box p="56" bg="bg">
        <ErrorState onAction={onRetry} />
      </Box>
    </IncomeTableSkeleton>
  );
};
